"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M1 23v-5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V23h2V12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V23h2v-8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V23h2V8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V23h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1Zm3 0v-5H2v5h2Zm6 0V13H8v10h2Zm6 0v-8h-2v8h2Zm6 0V9h-2v14h2ZM7.8 7.599 4.75 10.03A2.002 2.002 0 0 1 3 13a2.004 2.004 0 0 1-2-2.001 2.002 2.002 0 0 1 3.057-1.697l3.117-2.486A2.002 2.002 0 0 1 9 4a2.002 2.002 0 0 1 2 2.05l2.442.697a1.997 1.997 0 0 1 2.574-.47l3.261-3.261A2.002 2.002 0 0 1 21 0c1.103 0 2 .897 2 2a2.002 2.002 0 0 1-3.016 1.723l-3.261 3.261A2.002 2.002 0 0 1 15 10a2.002 2.002 0 0 1-1.973-2.332l-2.302-.656a2 2 0 0 1-2.926.587Zm-4.11 2.678A1.001 1.001 0 1 0 3 12a1.001 1.001 0 0 0 .69-1.723Zm4.548-3.63A1.001 1.001 0 1 0 9 5a1.001 1.001 0 0 0-.8 1.6.507.507 0 0 1 .038.047Zm12.075-3.92A1.001 1.001 0 1 0 21 1a1.001 1.001 0 0 0-.726 1.686.49.49 0 0 1 .04.04ZM15 7a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2Z",
    clipRule: "evenodd"
  })]
});